class HeaderScroll {
  constructor(el,opt){
    this.el = el;
    if($("." + this.el).length > 0){
      this.event();
    }
  }
  event(){
    const header = document.querySelector('.l-header__hum');
    const mvSection = document.querySelector('.s-mv');
  
    function toggleHeaderClass() {
      const mvRect = mvSection.getBoundingClientRect();
      if (mvRect.bottom <= 0) {
        header.classList.add('is-color');
      } else {
        header.classList.remove('is-color');
      }
    }
  
    window.addEventListener('scroll', toggleHeaderClass);
    toggleHeaderClass();
  }
}
